// Shared formatting/helpers for the SuperAdmin dashboard.
import type { ColorPaletteProp } from '@mui/joy';
import type { OrgStaleness } from '../../types/admin';

export const formatCurrency = (value: number | null | undefined): string => {
  const n = typeof value === 'number' ? value : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n);
};

export const STALENESS_META: Record<
  OrgStaleness,
  { label: string; color: ColorPaletteProp; dot: string }
> = {
  active: { label: 'Active', color: 'success', dot: 'var(--joy-palette-success-500)' },
  at_risk: { label: 'At Risk', color: 'warning', dot: 'var(--joy-palette-warning-500)' },
  stale: { label: 'Stale', color: 'danger', dot: 'var(--joy-palette-danger-500)' },
};

export const statusChipColor = (
  status: string | null,
  isFree: boolean | null
): ColorPaletteProp => {
  if (isFree) return 'neutral';
  switch (status) {
    case 'active':
      return 'success';
    case 'trialing':
      return 'primary';
    case 'past_due':
    case 'unpaid':
      return 'danger';
    case 'canceled':
    case 'incomplete':
    case 'incomplete_expired':
      return 'warning';
    default:
      return 'neutral';
  }
};
